namespace advisorop.components.advisor {

    export class CuAccountinvestmentController {

        // input params
        //account: domains.IAccount;
        appInitialized: boolean = false;
        formDataChanged: any;
        iAmReady: any;
        onSave: any;
        advisorIsDone: any;
        readyDone: boolean = false;

        user: domains.identity.IUser;
        impersonatedByServicer: boolean = false;

        // dropdowns
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        lovs: Array<domains.ILOV> = [];
        productTypes: domains.ILOV[] = [];
        managers: domains.IManager[] = [];
        products: domains.IManagerProduct[] = [];
        insuranceTypes: Array<domains.ILOV> = [];
        insuranceSubtypes: Array<domains.ILOV> = [];
        premiumModels: Array<domains.ILOV> = [];
        generalInvestmentAccountTypes: Array<domains.ILOV> = [];
        states: Array<domains.ILOV> = [];

        selProductType: domains.ILOV;
        selManager: domains.IManager;
        selProduct: domains.IManagerProduct;
        //selAdvisoryFirm: domains.IAdvisoryFirm;
        selPremiumModel: domains.ILOV;
        selPolicyType: domains.ILOV;
        selPolicySubtype: domains.ILOV;
        selGeneralInvestmentAccountType: domains.ILOV;
        selState: domains.ILOV;

        //insuranceType: number = domains.ManualAccountHoldingType.INSURANCE;
        hasInsuranceSubtypes: boolean = false;

        showGeneralAccountTypeField: boolean = false;
        showStateField: boolean = false;

        // types 
        accountType = domains.InvestmentType;
        productType = domains.ProductType;

        updatingAccountinvLadda: boolean = false;
        saveAllInformationToThisPointTooltipIsOpen2: boolean = false;

        accountType_OutsideInvestment: number = domains.InvestmentType.OUTSIDE_INVESTMENT;
        accountType_DirectInvestment: number = domains.InvestmentType.DIRECT_INVESTMENT;
        accountType_IndividualHoldings: number = domains.InvestmentType.INDIVIDUAL_HOLDINGS;
        accountType_ManagedModels: number = domains.InvestmentType.MANAGED_MODELS;
        accountType_SMA: number = domains.InvestmentType.SMA;
        accountType_CustodianAccount: number = domains.InvestmentType.CUSTODIAN_ACCOUNT;
        productType_LifeInsurance: number = domains.ProductType.LIFE_INSURANCE;
        productType_OtherInsurance: number = domains.ProductType.OTHER_INSURANCE;
        productType_Other: number = domains.ProductType.OTHER;
        completeColor: string = "lightgreen";
        incompleteColor: string = "yellow";
        investmentStatusColor: string = this.incompleteColor;
        feeStatusColor: string = this.incompleteColor;

        investmentInformationComplete: boolean = false;
        feeInformationComplete: boolean = false;

        showInvestmentsPanel: boolean = true;
        showFeesPanel: boolean = true;

        static $inject = ["generalService", "advisorService", "identityService", "advisoryFirmApi", "$scope", "accountApi"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private $scope: ng.IScope,
            public accountApi: services.AccountApi) {

            //$scope.$watch("this.accountApi.paccount.advisoryFirmId", () => {
            //});

            $scope.$watch("vm.accountApi.paccount.id", () => {
                if (this.accountApi.paccount.id > 0) {
                        this.bindWhenInitialized();
                }
            });
            $scope.$watch("vm.appInitialized", () => {
                if (this.appInitialized == true) {
                    //this.iAmReady({ ctrl: this });
                    //if (this.accountApi.paccount.id > 0) {
                    //    this.bindAccountForm();
                    //}
                }
            });
        }

        bindWhenInitialized(): void {
            if (this.appInitialized == true) {
                this.bindAccountForm()
                if (!this.readyDone) {
                    this.readyDone = true;
                    this.iAmReady({ ctrl: this });
                }
            } else {
                let that = this;
                setTimeout(function () { that.bindWhenInitialized() }, 250);
            }
        }

        expandAll(): void {
            this.showInvestmentsPanel = true;
            this.showFeesPanel = true;
        }

        collapseCompleted(): void {
            if (this.investmentInformationComplete) {
                this.showInvestmentsPanel = false;
            }
            if (this.feeInformationComplete) {
                this.showFeesPanel = false;
            }
        }

        collapseAll(): void {
            this.showInvestmentsPanel = false;
            this.showFeesPanel = false;
        }

        toggleInvestmentsPanel(): void {
            this.showInvestmentsPanel = !this.showInvestmentsPanel;
        }
        toggleFeesPanel(): void {
            this.showFeesPanel = !this.showFeesPanel;
        }

        printInfo(): boolean {
            //console.log("In PrintInfo -- ACCOUNT TYPE:", this.accountApi.paccount.accountType);
            return true;
        };

        // /////////////////////////////////////
        // account methods

        //setInvestorsDomain(): void {
        //}

        //validateAccountInformationForm(showMessage: boolean = true): boolean {
        //    let formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["accountinvestmentForm"]);

        //    if (!formIsValid && showMessage) {
        //        toastr.error("accountinvestmentForm -- Account application is not complete. Please correct errors and try again.");
        //    }

        //    return formIsValid;
        //};

        managerAndProductRequired(): boolean {
            if (this.accountApi.paccount.accountType != this.accountType_OutsideInvestment) {
                return true;
            } else {
                return false;
            }
        }

        investmentAmountRequired(): boolean {
            if (this.accountApi.paccount.accountType == this.accountType_DirectInvestment && (this.accountApi.paccount.productTypeId != this.productType_LifeInsurance && this.accountApi.paccount.productTypeId != this.productType_OtherInsurance)) {
                return true;
            } else {
                return false;
            }
        }

        public isCustodianRequired(): boolean {
            return (
                (this.accountApi.paccount.accountType &&
                    (this.accountApi.paccount.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS ||
                    this.accountApi.paccount.accountType == domains.InvestmentType.MANAGED_MODELS ||
                    this.accountApi.paccount.accountType == domains.InvestmentType.SMA)
                )
                // GL - note requiring custodian here in this screen any longer because the account could be a manual account
                // and the user needs to be able to update the account number.
                ||
                (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT
                    && this.accountApi.paccount.setupCustodianId
                    && this.accountApi.paccount.productTypeId == domains.ProductType.REIT
                    && (this.accountApi.paccount.titleType == domains.TitleType.IRA || this.accountApi.paccount.titleType == domains.TitleType.OTHER_RETIREMENT)
                )
            );
        }

        // Check account investment fields
        investmentFieldsComplete(): boolean {

            if (
                // product type
                this.accountApi.paccount.productTypeId &&
                // dropdown manager and product
                (this.managerAndProductRequired() == false || (this.accountApi.paccount.managerId && this.accountApi.paccount.productId)) &&
                // insurance policy type and subtype
                ((this.isInsuranceProduct() == false || this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) ||
                    (this.accountApi.paccount.manualAccount && this.accountApi.paccount.manualAccount.premiumMode && this.accountApi.paccount.manualAccount.policyInsuranceSubtype)) &&
                // general investment type
                (this.accountApi.paccount.productTypeId != domains.ProductType.GENERAL_INVESTMENT ||
                    (this.accountApi.paccount.manualAccount && this.accountApi.paccount.manualAccount.generalInvestmentAccountType != null)) &&
                // 529 state - currently we are not storing this state it seems (gl, need to fix)
                (this.showStateField == false || this.accountApi.paccount.jointTenancyState != null) &&
                // investment amount
                (this.investmentAmountRequired() == false || this.accountApi.paccount.investmentAmount > 0) &&
                // manually entered product company and product
                (this.accountApi.paccount.accountType != domains.InvestmentType.OUTSIDE_INVESTMENT ||
                    (this.accountApi.paccount.company != null && this.accountApi.paccount.company.length > 0 &&
                        this.accountApi.paccount.productDescription != null && this.accountApi.paccount.productDescription.length > 0)) &&
                // insurance benefit
                (this.isInsuranceProduct() == false || (this.accountApi.paccount.manualAccount && this.accountApi.paccount.manualAccount.benefit > 0)))
            {
                return true;
            } else {
                //console.log("ACCOUNT FIELDS ARE INCOMPLETE");

                //console.log("this.managerAndProductRequired()", this.managerAndProductRequired());
                //console.log("this.selManager", this.selManager);
                //console.log("this.selProduct", this.selProduct);
                //console.log("this.isInsuranceProduct()", this.isInsuranceProduct());
                //console.log("this.accountApi.paccount.productTypeId", this.accountApi.paccount.productTypeId);
                //console.log("this.investmentAmountRequired()", this.investmentAmountRequired());
                //console.log("this.accountApi.paccount.accountType", this.accountApi.paccount.accountType);

                return false;
            }
        }

        // Check fee fields
        feeFieldsComplete(): boolean {

            if (
                // advisory fee - fee can be 0 or greater, allows 0% or $0 entries
                ((this.accountApi.paccount.accountType != this.accountType_DirectInvestment || this.accountApi.paccount.productTypeId == this.productType_LifeInsurance || this.accountApi.paccount.productTypeId == this.productType_OtherInsurance) ||
                    (this.accountApi.paccount.advisoryFee != null && this.accountApi.paccount.advisoryFee >= 0))
            )
                {
                return true;
            } else {
                return false;
            }
        }

        // ////////////////////////////////
        // on change methods
        advisoryFirmChangedd(): void {

            //if (this.accountApi.paccount.advisoryFirmId) {

            //    console.log(`Advisory firm id changed to ${this.accountApi.paccount.advisoryFirmId}`);

            //    this.loadManagers();
            //    this.loadProducts();
            //}
        }

        productTypeChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in productTypeChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true) {
            // product type changed, so we reload our list of managers
                this.loadManagers();
                if (this.selProductType)
                    this.accountApi.paccount.productTypeId = this.selProductType.value;
                else
                    this.accountApi.paccount.productTypeId =  null;
            }

            this.selGeneralInvestmentAccountType = null
            this.generalInvAcctTypeChanged(changedByUserOnUI);

            // product type changed, so we blank out the selected manager
            this.selManager = null;
            this.managerChanged(changedByUserOnUI)

            this.selPremiumModel = null;
            this.premiumModelChanged(changedByUserOnUI);

            this.selPolicyType = null;
            if (this.isInsuranceProduct() && this.accountApi.paccount.manualAccount) {
                this.loadInsuranceTypes();
            }
            this.policyTypeChanged(changedByUserOnUI);

            this.showGeneralAccountTypeField = this.selProductType && (this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT);
            this.showStateField = this.selProductType && this.selProductType.value === domains.ProductType.P_529;

            if (changedByUserOnUI) {
                this.thisFormDataChanged("productType");
            }
        }

        generalInvAcctTypeChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in generalInvAcctTypeChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true && this.accountApi.paccount.manualAccount != null) {
                if (this.selGeneralInvestmentAccountType) {
                    this.accountApi.paccount.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
                } else {
                    this.accountApi.paccount.manualAccount.generalInvestmentAccountType = null;
                }
            }

            if (changedByUserOnUI) {
                this.thisFormDataChanged("generalInvestmentAccountType");
            }
        }

        stateChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in generalInvAcctTypeChanged...", changedByUserOnUI);

            // We are storing 529 state in the joint tenancy state...
            if (changedByUserOnUI == true) {
                if (this.selState) {
                    this.accountApi.paccount.jointTenancyState = this.selState.extra1;
                } else {
                    this.accountApi.paccount.jointTenancyState = null;
                }
            }

            if (changedByUserOnUI) {
                this.thisFormDataChanged("529State");
            }
        }

        managerChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in managerChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true) {
                // manager changed, so we reload our list of products
                this.loadProducts();
                if (this.selManager)
                    this.accountApi.paccount.managerId = this.selManager.id;
                else
                    this.accountApi.paccount.managerId = null;
            }

            this.selProduct = null;
            this.productChanged(changedByUserOnUI);

            if (changedByUserOnUI) {
                this.thisFormDataChanged("manager");
            }
        }

        productChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in productChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true) {
                if (this.selProduct)
                    this.accountApi.paccount.productId = this.selProduct.id;
                else
                    this.accountApi.paccount.productId = null;
            }

            this.loadAdvisoryFee();

            if (changedByUserOnUI) {
                this.thisFormDataChanged("product");
            }
        }

        inputChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in ipnutChanged...", changedByUserOnUI);
            if (changedByUserOnUI) {
                this.thisFormDataChanged("someInput");
            }
        }

        policyTypeChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in policyTypeChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true) {
                // policy type changed, so we reload our list of policy subtypes
                this.loadInsuranceSubtypes();
                if (this.accountApi.paccount.manualAccount != null) {
                    if (this.selPolicyType)
                        this.accountApi.paccount.manualAccount.policyInsuranceType = this.selPolicyType.value
                    else
                        this.accountApi.paccount.manualAccount.policyInsuranceType = null;
                }
            }

            this.selPolicySubtype = null;
            this.policySubtypeChanged(changedByUserOnUI);

            if (changedByUserOnUI) {
                this.thisFormDataChanged("policyType");
            }
        }

        policySubtypeChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in policySubtypeChanged...", changedByUserOnUI);

            if (changedByUserOnUI == true && this.accountApi.paccount.manualAccount != null) {
                if (this.selPolicySubtype)
                    this.accountApi.paccount.manualAccount.policyInsuranceSubtype = this.selPolicySubtype.value
                else
                    this.accountApi.paccount.manualAccount.policyInsuranceSubtype = null;
            }

            if (changedByUserOnUI) {
                this.thisFormDataChanged("policySubtype");
            }
        }

        premiumModelChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in premiumModelChanged...", changedByUserOnUI);

            if (this.selPremiumModel) {
                if (changedByUserOnUI && this.accountApi.paccount.manualAccount != null) {
                    this.accountApi.paccount.manualAccount.premiumMode = this.selPremiumModel.value;
                }
            }

            if (changedByUserOnUI) {
                this.thisFormDataChanged("premiumModel");
            }
        };

        investmentAmountChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in investmentAmountChanged...", changedByUserOnUI);

            if (changedByUserOnUI) {
                this.thisFormDataChanged("investmentAmount");
            }
        };

        advisoryFeeChanged(changedByUserOnUI: boolean = false): void {
            //console.log("in advisoryFeeChanged...", changedByUserOnUI);

            if (changedByUserOnUI) {
                this.thisFormDataChanged("advisoryFee");
            }
        };

        thisFormDataChanged(element: string) {
            //console.log("In CuAccountDataChanged based on", element);
            // Here we are detecting every change on the initial Account form,
            // to determine when the initial account details can be saved.

            this.investmentInformationComplete = this.investmentFieldsComplete();

            if (this.investmentInformationComplete) {
                this.investmentStatusColor = this.completeColor;
            } else {
                this.investmentStatusColor = this.incompleteColor;
            }

            this.feeInformationComplete = this.feeFieldsComplete();

            if (this.feeInformationComplete) {
                this.feeStatusColor = this.completeColor;
            } else {
                this.feeStatusColor = this.incompleteColor;
            }

            //console.log("investmentInformationComplete:", this.investmentInformationComplete);
            //console.log("feeInformationComplete:", this.feeInformationComplete);

            // Something has changed, mark appropriate section as dirty
            if (element == "advisoryFee") {
                this.accountApi.feeSetupDirty = true;
                //console.log("FEE SETUP DIRTY IS TRUE");
            } else {
                this.accountApi.investmentSetupDirty = true;
                //console.log("INVESTMENT SETUP DIRTY IS TRUE");
            }

            // callback to calling controller
            this.formDataChanged();
        }

        // ///////////////////////////////
        // load methods
        bindAccountFromForm() {

            //console.log("Binding account from form...");
            
            //if (this.selProductType && this.hasProductType()) {
            //    this.accountApi.paccount.productTypeId = this.selProductType.value;
            //}
            //else {
            //    this.accountApi.paccount.productTypeId = null;
            //}

            //// manager / company
            //if (this.selManager && this.hasProductType()) {
            //    this.accountApi.paccount.managerId = this.selManager.id;
            //}
            //else {
            //    this.accountApi.paccount.managerId = null;
            //}

            //// product
            //if (this.selProduct && this.hasProductType()) {
            //    this.accountApi.paccount.productId = this.selProduct.id;
            //}
            //else {
            //    this.accountApi.paccount.productId = null;
            //}

            //if (this.accountApi.paccount.manualAccount) {
            //    if (this.selProductType && this.selProductType.value === domains.ProductType.GENERAL_INVESTMENT && this.selGeneralInvestmentAccountType) {
            //        this.accountApi.paccount.manualAccount.generalInvestmentAccountType = this.selGeneralInvestmentAccountType.value;
            //    }
            //    else {
            //        this.accountApi.paccount.manualAccount.generalInvestmentAccountType = null;
            //    }
            //    console.log("this.accountApi.paccount.manualAccount.generalInvestmentAccountType", this.accountApi.paccount.manualAccount.generalInvestmentAccountType)
            //}
        }

        fromAccount: domains.IAccount

        bindAccountForm() {

            //console.log("cu-accountinvestment -- Binding account form: ", this.accountApi.paccount);

            this.selProductType = null;
            this.selManager = null;
            this.selProduct = null;

            if (this.accountApi.paccount.productTypeId && this.accountApi.paccount.productTypeId > 0) {
                this.selProductType = this.productTypes.filter(v => v.value == this.accountApi.paccount.productTypeId)[0];
                //console.log("SEL PRODUCT TYPE BOUND IS:", this.selProductType);
                this.productTypeChanged(false);

                if (this.selProductType.value == domains.ProductType.GENERAL_INVESTMENT) {
                    if (this.accountApi.paccount.manualAccount != null && this.accountApi.paccount.manualAccount.generalInvestmentAccountType != null) {
                        this.selGeneralInvestmentAccountType = this.generalInvestmentAccountTypes.filter(f => f.value === this.accountApi.paccount.manualAccount.generalInvestmentAccountType)[0];
                        this.generalInvAcctTypeChanged(false);
                    }
                }

                if (this.selProductType.value == domains.ProductType.P_529) {
                    if (this.accountApi.paccount.jointTenancyState != null) {
                        this.selState = this.states.filter(f => f.extra1 === this.accountApi.paccount.jointTenancyState)[0];
                        this.stateChanged(false);
                    }
                }

                if (this.accountApi.paccount.productTypeId && this.accountApi.paccount.productTypeId > 0) {
                    let me = this;
                    //console.log(".....GOING TO LOAD MANAGERS AND WAIT.....");
                    me.loadManagers().then(() => {
                        if (this.accountApi.paccount.managerId && this.accountApi.paccount.managerId > 0) {
                            this.selManager = this.managers.filter(f => f.id === this.accountApi.paccount.managerId)[0];
                            //console.log("MANAGER LOADED FROM DB:", this.selManager);
                            this.managerChanged(false);
                        }

                        if (this.accountApi.paccount.managerId && this.accountApi.paccount.managerId > 0) {
                            me.loadProducts().then(() => {
                                if (this.accountApi.paccount.productId && this.accountApi.paccount.productId > 0) {
                                    this.selProduct = this.products.filter(f => f.id === this.accountApi.paccount.productId)[0];
                                    //console.log("PRODUCT LOADED FROM DB:", this.selProduct);
                                    this.productChanged(false);
                                }
                            });
                        }
                    });
                }
            }

            if (this.isInsuranceProduct() && this.accountApi.paccount.manualAccount) {
                if (this.accountApi.paccount.manualAccount != null && this.accountApi.paccount.manualAccount.premiumMode != null) {
                    this.selPremiumModel = this.premiumModels.filter(v => v.value == this.accountApi.paccount.manualAccount.premiumMode)[0];
                    this.premiumModelChanged(false);
                }
                if (this.accountApi.paccount.manualAccount != null && this.accountApi.paccount.manualAccount.policyInsuranceType != null) {
                    this.selPolicyType = this.insuranceTypes.filter(v => v.value == this.accountApi.paccount.manualAccount.policyInsuranceType)[0];
                    this.policyTypeChanged(false);
                    this.loadInsuranceSubtypes();
                    this.selPolicySubtype = this.insuranceSubtypes.filter(v => v.value == this.accountApi.paccount.manualAccount.policyInsuranceSubtype)[0];
                    this.policySubtypeChanged(false);
                }
            }

            this.thisFormDataChanged("BINDFORM");
            this.accountApi.investmentSetupDirty = false;
            this.accountApi.feeSetupDirty = false;
            //console.log("INVESTMENT SETUP DIRTY IS FALSE");
            this.collapseCompleted();
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    //this.loadInsuranceTypes();

                    this.generalInvestmentAccountTypes = this.lovs.filter(v => v.lovType == domains.LovType.GENERAL_INVESTMENT_ACCOUNT_TYPES);

                    this.premiumModels = this.lovs.filter(v => v.lovType == domains.LovType.PREMIUM_MODE);

                    this.productTypes = this.lovs.filter(f => (f.lovType == domains.LovType.PRODUCT_TYPE));

                    this.states = this.lovs.filter((value, index, array) => { return value.lovType == domains.LovType.STATES });

                    this.appInitialized = true;

                }, err => this.generalService.showError(err));
        };

        loadInsuranceTypes(): void {
            if (this.selProductType) {
                this.insuranceTypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_TYPE && v.parentId == this.selProductType.value);
            }
        }

        loadInsuranceSubtypes(changedByUserOnUI: boolean = false): void {
            if (this.selPolicyType) {
                this.insuranceSubtypes = this.lovs.filter(v => v.lovType == domains.LovType.POLICY_INSURANCE_SUBTYPE && v.parentId == this.selPolicyType.value);
            }

            if (changedByUserOnUI == true) {
                if (this.accountApi.paccount.manualAccount != null) {
                    this.accountApi.paccount.manualAccount.policyInsuranceSubtype = null;
                }
                this.selPolicySubtype = null;
            }
        };

        loadGeneralInvestmentAccountTypes() {
        }

        loadManagers(): ng.IPromise<any> {
            if (this.selProductType) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getAllManagers(this.selProductType.value)
                        .then(response => {
                            this.managers = response.data;
                            //console.log("Managers loaded", this.managers);
                            return response;
                        }, err => this.generalService.showError(err));
                }
                else if (this.accountApi.paccount.advisoryFirmId && this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT) {
                    return this.advisorService.getManagers(this.accountApi.paccount.advisoryFirmId, this.selProductType.value)
                        .then(response => {
                            this.managers = response.data;
                            //console.log("Managers loaded", this.managers);
                            return response;
                        }, err => this.generalService.showError(err));
                }
                else {
                    //console.log("Missing account type or advisory firm!", this.accountApi.paccount.advisoryFirmId, this.accountApi.paccount.accountType);
                }
            } else {
                this.managers = null;
            }
        };

        loadProducts(): ng.IPromise<any> {
            if (this.selProductType && this.selManager) {
                // outside investment account should show global Managers and Products for selected product type and manager
                if (this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT) {
                    return this.advisorService.getProductsByManager(this.selProductType.value, this.selManager.id)
                        .then(response => {
                            this.products = response.data;
                            //console.log("Products loaded", this.products);
                        }, err => this.generalService.showError(err));
                }
                // direct investment account should show advisory firm Managers and Products for selected product type and manager
                else if (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT && this.accountApi.paccount.advisoryFirmId) {
                    return this.advisorService
                        .getProductsByFirm(this.accountApi.paccount.advisoryFirmId, this.selProductType.value, this.selManager.id, domains.InvestmentType.DIRECT_INVESTMENT)
                        .then(response => {
                            this.products = response.data;
                            //console.log("Products loaded", this.products);
                        }, err => this.generalService.showError(err));
                }
            } else {
                this.products = null;
            }
        };

        loadAdvisoryFee(changedByUserOnUI: boolean = false) {
            let feeOnProduct = false;

            if (changedByUserOnUI) {
                // If an advisory fee has already been set on this product do not change it
                if (this.accountApi.paccount.advisoryFee != null && this.accountApi.paccount.advisoryFee == 0) {

                    // take fee from product
                    if (this.selProduct && this.products.length > 0) {
                        this.products.filter(product => product.id === this.selProduct.id)[0].firmProducts.forEach(firmProduct => {
                            if (firmProduct.advisoryFee) {
                                this.accountApi.paccount.advisoryFee = firmProduct.advisoryFee;
                                feeOnProduct = true;
                                this.thisFormDataChanged("advisoryFee");
                                return;
                            }
                        });
                    }

                    //take default advisoryFirm fee
                    if (!feeOnProduct && this.accountApi.paccount.advisoryFirmId) {
                        this.advisoryFirms.forEach(firm => {
                            if (firm.id === this.accountApi.paccount.advisoryFirmId) {
                                this.accountApi.paccount.advisoryFee = firm.defaultAdvisoryFee;
                                this.thisFormDataChanged("advisoryFee");
                                return;
                            }
                        });
                    }
                }
            }
        }


        //hasProductType(): boolean {
        //    return this.accountApi.paccount.accountType &&
        //        (this.accountApi.paccount.accountType == domains.InvestmentType.DIRECT_INVESTMENT || this.accountApi.paccount.accountType == domains.InvestmentType.OUTSIDE_INVESTMENT);
        //};

        isInsuranceProduct(): boolean {
            return this.selProductType && (this.selProductType.value === domains.ProductType.LIFE_INSURANCE ||
                this.selProductType.value === domains.ProductType.OTHER_INSURANCE);
        }
        isAnnuityProduct(): boolean {
            return this.selProductType && (this.selProductType.value === domains.ProductType.ANNUITY);
        }
        isOtherProduct(): boolean {
            return this.selProductType
                && (this.selProductType.value !== domains.ProductType.ANNUITY)
                && (this.selProductType.value !== domains.ProductType.LIFE_INSURANCE)
                && (this.selProductType.value !== domains.ProductType.OTHER_INSURANCE);
        }
        
        loadAdvisoryFirms(): ng.IPromise<domains.IAdvisoryFirm[]> {
            return this.advisoryFirmApi.getAdvisoryFirms()
                .then(data => this.advisoryFirms = data.data, err => this.generalService.showError(err));
        };

        updateAccount(): ng.IPromise<boolean> {

            //this.updatingAccountinvLadda = true;

            //console.log("Account before update: ", this.accountApi.paccount);
            return this.advisorService.updateAccount(this.accountApi.paccount)
                .then(response => {
                    if (this.impersonatedByServicer == false) {
                        toastr.success("Account has been added to the queue and is ready for the Service Team to take over account opening.");
                        this.advisorIsDone();
                    } else {
                        toastr.success("Account has been updated.");
                    }
                    this.accountApi.paccount = response.data;
                    //console.log("Account after update: ", this.accountApi.paccount);
                    this.bindAccountForm();
                    return true;
                }, err => this.generalService.showError(err))
                .finally(() => this.updatingAccountinvLadda = false);
        };

        saveAccount(): void {
            // If the user is able to save at this stage, then we will move the account into PROPOSED state.
            // This will prevent advisor users from making any further changes to the account via the account opening process.
            // Servicer users who are impersonating advisor users will be able to make changes.

            // first call back to the calling controller (onSave method that was passed in) to save the FundingComponents
            this.updatingAccountinvLadda = true;
            this.saveAllInformationToThisPointTooltipIsOpen2 = false;
            this.onSave().then(success => {
                this.accountApi.paccount.status = domains.AccountStatus.PROPOSED;
                this.updateAccount();
            });
        }

        // overrides ...
        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.impersonatedByServicer = (this.user.impersonatedByRole == "SERVICER" || this.user.impersonatedByRole == "SERVICER_LEAD" || this.user.impersonatedByRole == "SERVICER_ADMIN")
            });
            this.loadAdvisoryFirms();
            this.loadLovs();
            //this.iAmReady({ ctrl: this });
        };

        $onChanges(event): void {
            //console.log("CuAccountinvestment: onChanges fired", event, this.advisoryFirm);
            //console.log("Acount on changes: ", this.account);
            //for (var key in event) {
            //    if (key === "advisoryFirm") {
            //       // console.log(`Binding advisory firm`, this.advisoryFirm);
            //        if (this.advisoryFirm) {
            //            this.account.advisoryFirm = this.advisoryFirm;
            //            this.account.advisoryFirmId = this.advisoryFirm.id;
            //            //this.selAdvisoryFirm = this.advisoryFirm;
            //            this.loadTamps(this.advisoryFirm.id);
            //        }
            //    }
            //}
        }

    }

    class CuAccountinvestment implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                //account: "=",
                iAmReady: "&",
                onSave: "&",
                advisorIsDone: "&",
                formDataChanged: "&"
            };
            this.controller = CuAccountinvestmentController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/cu-accountinvestment.html";
        }
    }
    angular.module(Constants.APP).component("cuAccountinvestment", new CuAccountinvestment());
}